;(() => {
  const $popupCart = document.querySelector('#s-popup-cart')
  if ($popupCart) {
    // Open the popup cart when clicked
    // const $headerBar = document.getElementById('s-header__bar_a-discount')
    // if ($headerBar) {
    //   $headerBar.addEventListener('click', function (event) {
    //     event.preventDefault()
    //     $popupCart.checked = true
    //   })
    // }

    // Open the cart when landed on /#open
    if (location.hash === '#open') {
      $popupCart.checked = true
    }
  }

  if (typeof window.bambooroll === 'undefined') {
    window.bambooroll = {}
  }
  window.bambooroll.popupCart = {
    open: function () {
      if ($popupCart) {
        $popupCart.checked = true
      }
    },
  }
})()
